export interface ImputableReason {
    value: string;
    /** false = legacy/renamed entry kept for historical matching; not shown in UI */
    active: boolean;
}

export interface ScoreConfig {
    punctualityWeight: number;
    permanenceWeight: number;
    deliveryWeight: number;
    loadPunctualityWeight: number;
    loadPermanenceWeight: number;
    /** 0 = only unload (default), 100 = only load, intermediate = weighted blend */
    loadDeliveryWeight: number;
    permanenceSensitivity: number;
    imputableFailOrderReasons: ImputableReason[];
    imputableOrderItemReasons: ImputableReason[];
}

export type PerTripDefinitionScoreConfig = Array<{ tripDefinition: string; value: ScoreConfig }>;

export const SCORE_CONFIG_DEFAULTS: ScoreConfig = {
    punctualityWeight: 60,
    permanenceWeight: 20,
    deliveryWeight: 20,
    loadPunctualityWeight: 40,
    loadPermanenceWeight: 50,
    loadDeliveryWeight: 0,
    permanenceSensitivity: 1.0,
    imputableFailOrderReasons: [],
    imputableOrderItemReasons: [],
};
